import i18n from "i18next";
import { initReactI18next } from "react-i18next";
let settings = require('./locales/settings.json');
i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: Object.assign({}, ...settings.languages.map(item => ({ [item]: { translation: require(`./locales/${item}.json`) } }))),
        fallbackLng: settings.language,
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        debug: true
    });
export default i18n;